import Children from 'rax-children';
import { isValidArray } from './fp';
import isValidElement from 'rax-is-valid-element';
export function getValidChildren(children) {
    if (!children) {
        return null;
    }
    else if (isValidElement(children)) {
        return children;
    }
    else if (Children.count(children) > 0) {
        const c = Children.toArray(children).filter((item) => !!item);
        return isValidArray(c) ? c : null;
    }
    else {
        return children;
    }
}
